export default "__VITE_ASSET__E_qyfGEh__"